import { AlertTriangle } from 'lucide-react';
import { withArticle } from '../../hooks/useDuplicateNameGuard';

export interface DuplicateNameHintProps {
  /** The entries already carrying the name typed; nothing is shown when empty. */
  matches: readonly { id: string; name: string; isActive?: boolean }[];
  /** Entity noun for the copy, e.g. "category". */
  entityLabel?: string;
}

/**
 * An inline note under a name field, shown while the name typed is one
 * another entry already has (case and spacing ignored). It warns; it does not
 * stop the save — that is asked once more when saving.
 */
export function DuplicateNameHint({ matches, entityLabel = 'entry' }: DuplicateNameHintProps) {
  if (matches.length === 0) return null;
  const first = matches[0];
  const inactive = matches.every((m) => m.isActive === false);
  return (
    <p
      role="status"
      className="mt-1 flex items-start gap-1 text-xs text-amber-700"
      data-testid="duplicate-name-hint"
    >
      <AlertTriangle size={12} className="mt-0.5 shrink-0" aria-hidden="true" />
      <span>
        {matches.length > 1
          ? `${matches.length} ${entityLabel === 'entry' ? 'entries' : `${entityLabel}s`} are already called "${first.name}"`
          : `${withArticle(entityLabel)} called "${first.name}" already exists`}
        {inactive ? ' (inactive)' : ''}
      </span>
    </p>
  );
}
